import axios from "axios";

import { envConfig } from "config/env";

export const refreshToken = async (refreshToken: string) => {
	const res = await axios.post(`${envConfig.API_URL}/auth/google/refresh-token`, { refreshToken });
	return res;
};
